import type { ApiError } from '@/types/api';
import { isApiError } from '@/utils/httpClient';

const CUSTOMER_INELIGIBLE_MESSAGE = 'customer not eligible for iem services';

const isEligibilityMessage = (message: string) =>
  message.toLowerCase().includes(CUSTOMER_INELIGIBLE_MESSAGE);

export const isCustomerEligibilityError = (error: unknown): error is ApiError => {
  if (!isApiError(error)) {
    return false;
  }

  if (error.status !== 403) {
    return false;
  }

  return isEligibilityMessage(error.message);
};

export const getEligibilityReason = (error: ApiError): string | undefined => {
  if (!isEligibilityMessage(error.message)) {
    return undefined;
  }

  const { details } = error;

  if (typeof details === 'string') {
    return details;
  }

  if (details && typeof details === 'object' && 'reason' in details) {
    const reason = (details as { reason?: unknown }).reason;
    if (typeof reason === 'string') {
      return reason;
    }
  }

  return undefined;
};
